import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/search.png'
import _imports_1 from '@/assets/image/icon/sqire.png'


const _withScopeId = n => (_pushScopeId("data-v-12ae8ad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-rt" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1
}, null, -1))

import { reactive, computed, watch, ref, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import PriceRange from '../common/PriceRange.vue'
import PlatSearchCondition from './PlatSearchCondition.vue'
import { bury } from '@/util/useBury'
import { useSite2Station, useSite, isEN } from '@/store'
import { Site } from '@/common/const'

interface S {
  label: string
  value: string
  channel: number | string | never
}

interface C {
  cateNameJp: string;
  cateNameKr?: string;
  cateNameEn?: string;
  cateNameZh?: string;

  productCategoryFrontendId: string | number
}


export default /*#__PURE__*/_defineComponent({
  emits: ['search', 'jump', 'reset'],
  setup(__props, { emit }) {



const store = useStore()
const buss = store.state.bussiness
const model = reactive(buss)
const stationCode = useSite2Station()

const changeCate = (v: any) => {
  const productCategoryFrontendIdNameZh = cates.value.find(i => i.productCategoryFrontendId === v)?.cateNameZh

  store.commit(
    'bussiness/productCategoryFrontendIdNameZh',
    productCategoryFrontendIdNameZh
  )
}

const Sellers = computed(() => {
  if (buss.schannel === '0' || buss.schannel === '2' || buss.schannel === '') {
    // 我的频道搜索与透明购一致
    return buss.Sellers
  } else {
    return buss.Sellers.filter(
      (v: S) => buss.schannel ? (!v.channel || v.channel === buss.schannel) : true
    )
  }
})

const cates: Ref<C[]> = ref([
  {
    cateNameJp: t('全部类目'),
    productCategoryFrontendId: ''
  }
])

const schannel = computed(() => buss.schannel)
buss.promise.then(() => {
  cates.value = buss.category[buss.schannel || '0']
  watch(schannel, (v) => {
    cates.value = buss.category[v]
  })
})

const sortTypes = computed(() => buss.SortTypes)
console.log(sortTypes.value, 'sortTypes', buss.platformType)

const labels = ['搜索范围', '类目', '搜索关键词'].map(t)

const ckb = ['排序', '价格区间'].map(t)

const reset = () => {
  bury('Popup_Click_Reset')
  emit('reset', true)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content", _unref(useSite)()])
  }, [
    _createVNode(_component_el_form, {
      model: _unref(model),
      inline: true,
      "label-width": _unref(isEN)() ? '100px' : '85px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(labels)[0]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(model).platformType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).platformType) = $event)),
              class: "plat",
              teleported: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Sellers), (v) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('Popup_Click_SearchRange'))),
                    key: v.value,
                    value: v.value,
                    label: _unref(t)(v.label)
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(labels)[1],
          class: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              onChange: changeCate,
              modelValue: _unref(model).productCategoryFrontendId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).productCategoryFrontendId) = $event)),
              class: "cate",
              teleported: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cates.value, (v) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(bury)('Popup_Click_Category'))),
                    key: v.productCategoryFrontendId,
                    value: v.productCategoryFrontendId,
                    label: {
              [_unref(Site).JA]: v.cateNameJp,
              [_unref(Site).KO]: v.cateNameKr,
              [_unref(Site).EN]: v.cateNameEn,
            }[_unref(stationCode)]
              
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(labels)[2]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, _mergeProps({
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_unref(bury)('Popup_Click_KeyWords'))),
              class: "keyword",
              type: "text"
            }, _ctx.$attrs, { maxlength: "100" }), null, 16)
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(buss).platformType === '')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_form_item, {
                label: _unref(ckb)[0]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(model).sortType,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(model).sortType) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortTypes), (v) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(bury)('Popup_Click_Sort'))),
                          key: v.name,
                          label: v.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(ckb)[1]
              }, {
                default: _withCtx(() => [
                  _createVNode(PriceRange, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(bury)('Popup_Click_PriceRange'))),
                    min: _unref(model).sellPriceStart,
                    "onUpdate:min": _cache[8] || (_cache[8] = ($event: any) => ((_unref(model).sellPriceStart) = $event)),
                    max: _unref(model).sellPriceEnd,
                    "onUpdate:max": _cache[9] || (_cache[9] = ($event: any) => ((_unref(model).sellPriceEnd) = $event))
                  }, null, 8, ["min", "max"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : (_unref(buss).platformType === 'WS' || _unref(buss).platformType === 'VC')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
            : (_unref(buss).platformType.split('SC').length < 2)
              ? (_openBlock(), _createBlock(PlatSearchCondition, { key: 2 }))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "label-width"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "search-btn",
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('search')))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_unref(t)('站内搜索')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "search-btn",
          type: "primary",
          disabled: !_unref(buss).platformType,
          onClick: _cache[11] || (_cache[11] = ($event: any) => {_unref(bury)('Popup_Click_OffSiteSearch'); emit('jump')})
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_unref(t)('外部搜索')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "text",
          onClick: reset
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('重置条件')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})